import { useTranslation } from 'react-i18next';
import { BottomTabBar } from '@/components/ui/BottomTabBar';
import { GlobalHeader } from '@/components/GlobalHeader';
import { SubscriptionTiers } from '@/components/SubscriptionTiers';
import { useAuthStore } from '@/store/authStore';
import { useChildProfile } from '@/services/children';

export function StudentSubscriptionPage() {
  const { t } = useTranslation();
  const { childId } = useAuthStore();
  const { data: profile } = useChildProfile(childId ?? '');

  return (
    <div className="page-center">
      <div className="phone-mockup">
        <GlobalHeader />
        <div className="app-content" style={{ paddingBottom: '24px' }}>

          <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: 'var(--text-dark)', margin: '0 0 24px' }}>
            {t('student_subscription.title')}
          </h1>

          <SubscriptionTiers countryCode={profile?.country} />

        </div>

        <BottomTabBar activeTab="More" />
      </div>
    </div>
  );
}
